import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {


  navBoolean: boolean = false;
  constructor() { }

  ngOnInit(): void {
  }

  animar(){
    const fondoNav = document.getElementById('nav');
    const divTarjeta = document.getElementById('divTarjeta');
    const div1 = document.getElementById('div1');
    const div2 = document.getElementById('div2');
    const div3 = document.getElementById('div3');
    const div4 = document.getElementById('div4');
    if(this.navBoolean){
      fondoNav.classList.replace('mostrarNav','ocultarNav');
      divTarjeta.classList.replace('mostrarTarjeta', 'ocultarTarjeta');
      div1.classList.replace('mostrarDiv1', 'ocultarElementoNav');
      div2.classList.replace('mostrarDiv2', 'ocultarElementoNav');
      div3.classList.replace('mostrarDiv3', 'ocultarElementoNavAbajo');
      div4.classList.replace('mostrarDiv4', 'ocultarElementoNavAbajo');
    }else{
      fondoNav.classList.replace('ocultarNav','mostrarNav');
      divTarjeta.classList.replace('ocultarTarjeta', 'mostrarTarjeta');
      div1.classList.replace('ocultarElementoNav','mostrarDiv1');
      div2.classList.replace('ocultarElementoNav','mostrarDiv2');
      div3.classList.replace('ocultarElementoNavAbajo','mostrarDiv3');
      div4.classList.replace('ocultarElementoNavAbajo','mostrarDiv4');
    }
    this.navBoolean = !this.navBoolean;
  }

}
